export default __webpack_public_path__ + "1d36f87ab3a27c6c3eaf0f04e6e29727.png";